// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"freeTextQuestion__wrapper__3A7ql","coverWrap":"freeTextQuestion__coverWrap__1CM-b","rotmanFadeLeft":"freeTextQuestion__rotmanFadeLeft__2Q1KG"};